import i18n from '@pro/common/i18n/i18n';
import { mutations, store } from './store';
import { MessageBox, Loading } from 'hui-intl';
import { getErrorTip, handleError } from './errorHandler';
import Cookie from 'js-cookie';

export const handleErrorDoCommon = (err, response, callback) => {
  if (err.errorCode === 'LAP000000') {
    console.error(`[LAP000000]${ response.config.url}`);
  }
  if (store.preErrorCode === err.errorCode) {
    setTimeout(() => {
      if (
        err.errorCode !== 'LAP001004'
        && err.errorCode !== 'LAP001032'
        && err.errorCode !== 'LAP002055'
        && err.errorCode !== 'VMS002030'
      ) {
        mutations.setPreErrorCode('');
      }
    }, 60000);
    return;
  }
  mutations.setPreErrorCode(err.errorCode);
  let title = i18n.t('error');
  let type = 'error';
  if (
    err.errorCode === 'LAP001004'
    || err.errorCode === 'LAP001032'
    || err.errorCode === 'LAP002055'
    || err.errorCode === 'VMS002030'
  ) {
    //会话不存在
    title = i18n.t('confirm');
    type = 'warning';
    if (window.singleGlobalLogout) {
      return;
    }
    window.singleGlobalLogout = true;
  }
  if (err.errorCode === 'LAP001004' && Cookie.get('portalAutoLoginId')) {
    return MessageBox({
      title,
      message: getErrorTip(err.errorCode, response),
      cancelButtonText: i18n.t('confirm'),
      showConfirmButton: true,
      confirmButtonText: i18n.t('relogin'),
      showCancelButton: true,
      closeOnClickModal: false,
      type: 'error'
    })
      .then(() => {
        window.singleGlobalLogout = false;
        handleError(err.errorCode);
        mutations.setPreErrorCode(null);
      })
      .catch(() => {
        window.singleGlobalLogout = false;
        handleError('LAP001032');
        mutations.setPreErrorCode(null);
      });
  }
  // eslint-disable-next-line new-cap
  return MessageBox({
    title,
    type,
    message: getErrorTip(err.errorCode, response)
  })
    .then(() => {
      handleError(err.errorCode);
      mutations.setPreErrorCode(null);
      if (callback && typeof callback === 'function') {
        callback(err);
      }
    })
    .catch(() => {
      handleError(err.errorCode);
      mutations.setPreErrorCode(null);
      if (callback && typeof callback === 'function') {
        callback(err);
      }
    })
    .finally(() => {
      Loading.service().close();
      if (
        err.errorCode === 'LAP001004'
        || err.errorCode === 'LAP001032'
        || err.errorCode === 'LAP002055'
        || err.errorCode === 'VMS002030'
      ) {
        window.singleGlobalLogout = false;
        mutations.setPreErrorCode('');
      }
    });
};
